<template lang="pug">
.product-chooser
  //- .backdrop
  .popup.bg-white.rounded.shadow-lg.d-flex
    .d-flex.flex-row.w-100
      .border-right.flex-grow-1.d-flex.flex-column(style="width: 50%;")
        .p-4.border-bottom.d-flex
          .p-0.flex-fill: h3.mb-0 เลือกสินค้า
          .flex-fill.d-flex.align-items-center
            template(v-if="isSearchResult")
              .w-100.text-right
                button.btn.btn-secondary(
                  @click="closeSearch") ปิดการค้นหา
            .steppers(v-else)
              .stepper.is-active(
                @click="clearAll()")
                  | 1
              .stepper(
                :class="{'is-active': selectedCategory !== -1}"
                @click="clearPaginate(); selectedSubCategory = -1; selectedProduct = -1"
                ) 2
              .stepper(
                :class="{'is-active': selectedSubCategory !== -1 && selectedCategory !== -1}"
              ) 3
        .px-4.py-3.border-bottom.search-area.d-flex
          .flex-fill.d-flex.align-items-center
            template(v-if="isSearchResult || selectedSubCategory !== -1") ผลการเลือกสินค้า
            template(v-else-if="selectedCategory === -1") เลือกประเภท
            template(v-else-if="selectedSubCategory === -1") เลือกประเภทย่อย
          .flex-fill(style="max-width: 260px;")
            InputWithIconSlot(
              v-model="searchProductString" placeholder="ค้นหาด้วยชื่อ" width="100%")
              i.fa.fa-search
        template(v-if="isSearchTyping")
          .py-3.px-4.text-right
            button.btn.btn-link.text-secondary.btn-outline-secondary.shadow-0.border-0.mr-2(
              @click="closeSearch"): u ปิดการค้นหา
            button.btn.btn-primary(@click="doSearch") ทำการค้นหา
        template(v-else-if="isSearchResult || selectedSubCategory !== -1")
          .flex-fill(style="overflow-y: auto; overflow-x: hidden;")
            .text-center.py-2.text-secondary: small ทั้งหมด {{productPaginationTotalItem}} รายการ
            .border-left.border-bottom.p-0(v-for="product in products")
              button.product-btn.w-100.text-left.p-3.d-flex.align-items-center(
                :class="{'is-active': selectedProduct === product.productCode}"
                :disabled='preSelectedProductsId.includes(product.productCode)'
                @click="selectedProduct = product.productCode"
              )
                .img-container.d-inline-flex.justify-content-center.align-items-center.mr-3.mb-0
                  img.checkmark.img-48.rounded-circle(src="@/assets/icons/check.png")
                  img.product-img.img-48.rounded-circle(:src="product.image")
                .container
                  .row
                    .col-4
                      p.m-0(style="opacity: 0.5;"): small รหัสสินค้า
                      p.m-0 {{product.productCode}}
                    .col-8
                      p.m-0(style="opacity: 0.5;"): small ชื่อสินค้า
                      p.m-0
                        | {{product.productName}}
                        template(v-if="product.amountInOneBigUnit !== 1")
                          | &nbsp;
                          | ({{product.amountInOneBigUnit}}
                          |
                          | {{product.unit}} / 1 {{product.bigUnit}})
                    .col-4.mt-1
                      p.m-0(style="opacity: 0.5;"): small ราคาขายล่าสุด
                      p.m-0.text-danger
                        template(v-if="product.latestSellPrice")
                          | {{product.latestSellPrice | currency}}
                        template(v-else) -
                    .col-4.mt-1
                      p.m-0(style="opacity: 0.5;"): small น้ำหนัก
                      p.m-0.text-danger {{product.weight}} กก.
                  template(v-if='preSelectedProductsId.includes(product.productCode)')
                    .text-right.text-small.text-red (คุณได้เลือกรายการนี้ไปแล้ว)
            .sticky-bottom.p-4(style="background-color: rgba(255, 255, 255, 0.95)")
              CustomPaginationSuperCompact(
                v-model='productPaginationPage'
                :total='productPaginationLast'
                :compact="true"
              )
        template(v-else-if="selectedCategory === -1")
          .flex-fill(style="overflow-y: auto;  overflow-x: hidden;")
            .row.px-3
              .col-6.border-left.border-bottom.p-0(v-for="category in categories")
                button.category-btn.w-100.text-left.py-3.d-flex.align-items-center.h-100(
                  @click="selectedCategory = category.id;"
                )
                  .d-inline-flex.justify-content-center.align-items-center.text-white.h5.mr-3.mb-0(
                    class="img-36 bg-upa-blue-gradient rounded-circle" style="flex: 0 0 36px")
                      | {{category.id}}
                  p.h5.mb-0.font-weight-normal {{category.name}}
        template(v-else-if="selectedSubCategory === -1")
          .flex-fill(style="overflow-y: auto;  overflow-x: hidden;")
            .row.px-3
              .col-6.border-left.border-bottom.p-0(v-for="subCategory in subCategories")
                button.category-btn.w-100.text-left.py-3.d-flex.align-items-center.h-100(
                  @click="selectedSubCategory = subCategory.id"
                )
                  .d-inline-flex.justify-content-center.align-items-center.text-white.h5.mr-3.mb-0(
                    class="img-36 bg-upa-turquiose-gradient rounded-circle" style="flex: 0 0 36px")
                      | {{subCategory.id}}
                  p.h5.mb-0.font-weight-normal {{subCategory.name}}
      .flex-grow-1(style="width: 50%; overflow-y: auto; position: relative;")
        .text-right
          button.img-36(style="background: none; border: none;" @click="$emit('close')")
            img.img-24(src="@/assets/icons/close.png")
        template(v-if="selectedProduct !== -1")
          .container-fluid: .row
            .col-5.input-sell-price.pr-0
              span ระบุราคาขาย
              input.border.rounded(
                type="number" v-model.number="productMetric.sellPrice"
                :class=`{
                  'border-danger': !isCommissionValid(product),
                  'border-success': isCommissionValid(product)
                  }`
                )
            .col-7.input-amount
              span จำนวนสินค้า ({{product.unit}})
              input.border.rounded(
                type="number" v-model.number="productMetric.amount"
                :class=`{
                  'border-danger': productMetric.amount <= 0,
                  'border-success': productMetric.amount > 0
                  }`
                )
            .col-12.text-right(v-if="product.amountInOneBigUnit !== 1")
              .mt-2.mb-0.d-flex.align-items-center.justify-content-end
                span.mr-2
                  | {{product.amountInOneBigUnit}} {{product.unit}} / 1 {{product.bigUnit}}
                template(v-if="productMetric.amount > 0 && !isAmountValid()")
                  .d-none
                    | {{ newBig = Math.ceil(productMetric.amount / product.amountInOneBigUnit)}}
                    | {{ newSmall = newBig * product.amountInOneBigUnit }}
                  span.mr-2.text-danger จำนวนไม่ลง{{product.bigUnit}}
                  button.btn.btn-outline-secondary.btn-sm.ml-1(
                    @click='productMetric.amount = newSmall'
                  )
                    | ปัดขึ้นเป็น
                    | {{newBig}}
                    |
                    | {{product.bigUnit}}
                template(v-else)
                  button.btn.btn-outline-secondary.btn-sm.ml-1(
                    v-for="plusAmount in [1, 2, 4, 10]"
                    @click="productMetric.amount += product.amountInOneBigUnit * plusAmount")
                      | + {{plusAmount}} {{product.bigUnit}}
          .p-3
            .h6 ระดับราคาและคอมมิชชั่น
            table.table.table-striped.commission-table
              thead
                tr
                  th.py-2 &nbsp;
                  th.py-2.text-center ระดับ
                  th.py-2.text-right ราคาสินค้ารวมค่าคอม
                  th.py-2.text-right ค่าคอมที่ได้รับ
              tbody
                tr.commission-row(
                  v-for="(lvl, i) in product.levels"
                  :class="{'is-active': isCommissionLevelActive(product, i)}"
                  )
                  td(@click="productMetric.sellPrice = lvl.sellPriceMin")
                    .checkmark-container.rounded-circle.bg-upa-blue-gradient.img-24
                      img.img-24.checkmark(src="@/assets/icons/check.png")
                  td.text-center(@click="productMetric.sellPrice = lvl.sellPriceMin") {{i+1}}
                  td.text-right.py-2
                    button.specific-level(
                      @click.prevent="productMetric.sellPrice = lvl.sellPriceMin")
                      | {{lvl.sellPriceMin | currency}}
                    | &nbsp;-&nbsp;
                    button.specific-level(
                      @click.prevent="productMetric.sellPrice = lvl.sellPriceMax")
                      | {{lvl.sellPriceMax | currency}}
                  td.text-right(@click="productMetric.sellPrice = lvl.sellPriceMin")
                    | ≈ {{calculateCommissionRow(product, lvl.sellPriceMin) | currency}}
            hr
            .row
              .col.text-right.d-flex.align-items-center.justify-content-end
                div
                  span ค่าสินค้า
                  .h3.mb-0 {{productMetric.sellPrice * productMetric.amount | currency}}
                img.ml-3.img-48(src="@/assets/icons/box.png")
              .col.text-right.d-flex.align-items-center.justify-content-end
                div
                  span ค่าคอมที่ได้รับ
                  .h3.mb-0 {{calculateCommission(product) | currency}}
                img.ml-3.img-48(src="@/assets/icons/investment.png")
          button.btn.btn-upa-secondary.btn-block.rounded-0.btn-lg(
            :disabled="!(isAmountValid() && isCommissionValid(product))"
            @click="addProduct()"
            ) เพิ่มสินค้า
          //- p {{product}}
</template>

<script>
import calculator from '@/calculator';

// TODO: implement pagination
// TODO: refactor this component

export default {
  data: () => ({
    categories: [],
    subCategories: [],
    products: [],
    searchProductString: '',
    lastSearchedString: '',
    selectedCategory: -1,
    selectedSubCategory: -1,
    selectedProduct: -1,
    selectedProductLevels: [],
    productMetric: {
      amount: 0,
      sellPrice: 0,
    },
    isSearchingLoading: false,
    productPaginationPage: 1,
    productPaginationLast: 1,
    productPaginationTotalItem: 0,
  }),
  watch: {
    productPaginationPage() {
      this.selectedProduct = -1;
      this.products = [];
      if (this.isSearchResult) {
        this.$nextTick(() => { this.doSearch(); });
      } else {
        this.$nextTick(() => {
          this.fetchProductsBySubCatId(this.selectedCategory, this.selectedSubCategory);
        });
      }
    },
    async selectedCategory(newVal) {
      if (newVal !== -1) {
        await this.fetchSubCategory(newVal);
      }
    },
    async selectedSubCategory(newVal) {
      if (newVal !== -1) {
        await this.fetchProductsBySubCatId(this.selectedCategory, newVal);
      }
    },
    async selectedProduct(newVal) {
      if (newVal !== -1) {
        this.selectedProductLevels = [];
        await this.fetchProductLevel(newVal);
      }
    },
  },
  computed: {
    isSearchTyping() {
      return this.searchProductString !== this.lastSearchedString;
    },
    isSearchResult() {
      return this.lastSearchedString !== '';
    },
    product() {
      const productsFiltered = this.products
        .filter(elm => elm.productCode === this.selectedProduct);
      if (productsFiltered.length === 0) {
        console.error('filtered got zero');
        return {};
      }
      productsFiltered[0].levels = this.selectedProductLevels;
      return productsFiltered[0];
    },
  },
  async created() {
    // await this.fetchProductsBySubCatId(1); // temp
    const res = await this.$api.product.getCategories();
    if (res.status === 200) {
      this.categories = res.data;
    }
  },
  methods: {
    clearAll() {
      this.clearPaginate();
      this.selectedCategory = -1;
      this.selectedSubCategory = -1;
      this.selectedProduct = -1;
    },
    closeSearch() {
      this.lastSearchedString = '';
      this.searchProductString = '';
      this.selectedProduct = -1;
      this.selectedCategory = -1;
      this.selectedSubCategory = -1;
    },
    clearPaginate() {
      this.productPaginationPage = 1;
      this.productPaginationLast = 1;
      this.productPaginationTotalItem = 1;
    },
    async doSearch() {
      this.products = [];
      this.lastSearchedString = this.searchProductString;
      // TODO: replace -1 with custID when upa-back#41 is fixed
      const res = await this.$api.product.search(
        this.lastSearchedString,
        -1,
        this.productPaginationPage,
      );
      if (res.status === 200) {
        this.products = res.data.data;
        this.productPaginationPage = res.data.current_page;
        this.productPaginationLast = res.data.last_page;
        this.productPaginationTotalItem = res.data.total;
      }
    },
    addProduct() {
      if (!(this.isAmountValid() && this.isCommissionValid(this.product))) return;
      const res = {
        product: {},
        amount: -1,
        sellPrice: -1,
        priceLevel: -1,
      };
      res.product = this.product;
      res.amount = this.productMetric.amount;
      res.sellPrice = this.productMetric.sellPrice;
      res.priceLevel = calculator.determineCommissionLevel(res.product.levels, res.sellPrice);
      this.$emit('selected', res);
    },
    calculateCommission(product) {
      return calculator.productCommission(
        product.levels,
        this.productMetric.sellPrice,
        this.productMetric.amount,
      );
    },
    isAmountValid() {
      if (this.productMetric.amount <= 0) return false;
      if (this.product.amountInOneBigUnit !== 1) {
        // if (this.productMetric.amount < this.product.amountInOneBigUnit) return false;
        if ((this.productMetric.amount / this.product.amountInOneBigUnit)
          % 1 !== 0) return false;
      }
      return true;
    },
    isCommissionValid(product) {
      return calculator.determineCommissionLevel(
        product.levels, this.productMetric.sellPrice,
      ) !== -1;
    },
    isCommissionLevelActive(product, level) {
      return (level + 1) === calculator
        .determineCommissionLevel(product.levels, this.productMetric.sellPrice);
    },
    calculateCommissionRow(product, minimumSellPrice) {
      // return '';
      return calculator.productCommission(
        product.levels,
        minimumSellPrice,
        (this.productMetric.amount <= 0) ? 1 : this.productMetric.amount,
      );
    },
    async fetchSubCategory(catId) {
      const res = await this.$api.product.getSubCategories(catId, this.customer.id);
      if (res.status === 200) {
        this.subCategories = res.data;
      }
    },
    /* eslint-disable */
    async fetchProductsBySubCatId(catId, subCatId) {
      const res = await this.$api.product.listBySubCategory(catId, subCatId, this.customer.id, this.productPaginationPage);
      // const res = await this.$api.product.listBySubCategory('all');
      if (res.status === 200) {
        this.products = res.data.data;
        this.productPaginationPage = res.data.current_page;
        this.productPaginationLast = res.data.last_page;
        this.productPaginationTotalItem = res.data.total;
      }
    },
    async fetchProductLevel(prodId) { // TODO:
      const res = await this.$api.product.getLevel(prodId, this.customer.grade);
      this.selectedProductLevels = res.data;
    },
  },
  props: {
    customer: {
      default: () => ({ id: 'CUSTID' }),
    },
    preSelectedProductsId: {
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.product-chooser {
  position: fixed;
  top: 0; bottom: 0; left: 0; right: 0;
  z-index: 30;
  .backdrop {
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
  }
  .popup {
    position: absolute;
    $padding: 12px;
    top: $padding; bottom: $padding; left: $padding; right: $padding;
  }
  .category-btn, .product-btn {
    border: none;
    background: none;
  }
  .product-btn {
    .img-container { position: relative; }
    .checkmark { display: none; }
    &.is-active {
      .checkmark {
        display: block;
      }
      .img-container {
        .product-img { opacity: 0.5; }
      }
      color: #ffffff !important;
      background: linear-gradient(to right, $upa-blue, $upa-turquoise);
    }
    &:disabled {
      .checkmark {
        display: block;
      }
      .img-container {
        .product-img { opacity: 0.5; }
      }
      // color: #ffffff !important;
      background: rgba(#000, 0.05);
    }
  }
  .input-sell-price span { right: 8px; }
  .input-amount span { right: 24px; }
  .input-sell-price, .input-amount {
    position: relative;
    padding-top: 16px;
    span {
      position: absolute;
      top: 20px;
      opacity: 0.8;
    }
    input {
      padding: 8px;
      padding-top: 24px;
      padding-bottom: 0px;
      font-size: 36px;
      width: 100%;
      text-align: right;
      line-height: 1;
    }
  }
  .commission-table {
    .checkmark-container {
      position: relative;
      opacity: 0.25;
      .checkmark {
        border-radius: 48px;
        background: white;
      }
    }
    .commission-row {
      &.is-active {
        background: linear-gradient(
          to right,
          rgba(#DCE4EE, 0.0),
          rgba(saturate(darken(#DCE4EE, 15), 50), 0.75)
        );
      }
      &.is-active {
        .checkmark-container {
          opacity: 1;
          .checkmark {
            display: block;
            background: none;
          }
        }
      }
      button.specific-level {
        background-color: rgba(#fff, 0.35);
        border-radius: 4px;
        padding: 2px 8px;
        min-width: 72px;
      }
    }
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    filter: brightness(0) invert(1);
    transform: scale(0.75);
    z-index: 3;
  }
}
</style>
